import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleX } from 'Images';
import { ignoreHyphenFilterOptions } from 'Utils/ignoreHyphenFilterOptions';
import { replaceZerosWithHyphen } from 'Utils/replaceZerosWithHyphen';
import { useContext, useState } from 'react';

export const ReferralNumber = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .search.advancedSearch;
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const [inputValue, setInputValue] = useState('');

  const setRequestNumber = (requestNumber: string | null) => {
    dispatchAdvancedSearch({
      type: 'REQUEST_NUMBER',
      payload: { value: requestNumber },
    });
  };

  return (
    <Box position={'relative'} top={'-2px'}>
      <ControlledAutocomplete
        freeSolo
        label={dictionary.accordingToRequestNumber}
        options={advancedSearch.requestNumberList.map((number) =>
          replaceZerosWithHyphen(number)
        )}
        filterOptions={ignoreHyphenFilterOptions}
        value={inputValue || ''}
        setValue={setRequestNumber}
        inputValue={inputValue}
        setInputValue={setInputValue}
        inputProps={{ inputMode: 'decimal' }}
        paperComponent={
          inputValue.length !== 0 &&
          advancedSearch.requestNumberList
            .map((number) => replaceZerosWithHyphen(number))
            .filter((value) =>
              value
                .toString()
                .replaceAll('-', '')
                .includes(inputValue.replaceAll('-', ''))
            ).length === 0 && (
            <Stack>
              <Typography variant={'body3'}>
                {Dictionary[DICTIONARY.PaymentsDeductions].search.noResult}
              </Typography>
            </Stack>
          )
        }
        disableClearIcon
        endAdornment={
          <Stack
            direction={'row'}
            marginRight={'5px'}
            width={'auto'}
            gap={'15px'}
          >
            {inputValue.length !== 0 && (
              <ButtonBase
                onClick={() => {
                  setInputValue('');
                  setRequestNumber(null);
                }}
              >
                <Avatar
                  alt={''}
                  src={PurpleX}
                  sx={{ width: '20px', height: '20px' }}
                />
              </ButtonBase>
            )}
          </Stack>
        }
      />
    </Box>
  );
};
